module.exports = __webpack_public_path__ + "img/resul_four_day_march_logo.2d45e4f9.png";